import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { validateOnStartup } from './utils/env';
import './index.css';

// Validate environment variables on startup (don't let validation throw in dev)
try {
  validateOnStartup();
} catch (err) {
  if (import.meta.env.DEV) {
    console.error('Environment validation failed (non-fatal):', err);
  }
}

// Fetch public site settings (footer text + site title) and set document title before render
async function loadAndRender() {
  try {
    const res = await fetch('/api/public/site-settings');
    if (res.ok) {
      const data = await res.json();
      if (data.siteTitle) document.title = data.siteTitle;
    }
  } catch (err) {
    // ignore - fall back to static title
  }

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

loadAndRender();
